import React from "react";
import { Link } from "react-router-dom";
import { FaCarSide, FaTaxi, FaStar } from "react-icons/fa";

const services = [
  {
    id: "economy",
    name: "Economy",
    icon: <FaCarSide className="text-blue-600 text-4xl mb-3" />,
    description: "Affordable and fuel-efficient. Best for budget-conscious riders.",
    startingPrice: "₹600",
    features: [
      "Available as Shared or Full Cab",
      "Great for solo or duo rides",
      "Compact and efficient",
    ],
  },
  {
    id: "standard",
    name: "Standard",
    icon: <FaTaxi className="text-blue-600 text-4xl mb-3" />,
    description: "Comfortable mid-range cars ideal for small families or groups.",
    startingPrice: "₹1000",
    features: [
      "Available as Shared or Full Cab",
      "Room for 3–4 passengers",
      "Air conditioned & spacious",
    ],
  },
  {
    id: "luxury",
    name: "Luxury",
    icon: <FaStar className="text-blue-600 text-4xl mb-3" />,
    description: "Premium vehicles and top-tier service for a luxurious experience.",
    startingPrice: "₹3000",
    features: [
      "Available as Shared or Full Cab",
      "High-end interiors & professional drivers",
      "Extra amenities (water, charger, etc.)",
    ],
  },
];

const Services = () => {
  return (
    <section className="py-12 px-6 md:px-20 bg-white font-lato">
      <h2 className="text-3xl font-bold text-blue-900 mb-10 text-center">
        Our Services
      </h2>

      <div className="flex flex-col md:flex-row justify-center gap-8 flex-wrap">
        {services.map(({ id, name, icon, description, startingPrice, features }) => (
          <div
            key={id}
            className="flex flex-col items-center bg-blue-50 border border-blue-200 rounded-lg p-6 max-w-xs shadow-md hover:shadow-xl transition-shadow"
          >
            {icon}
            <h3 className="text-xl font-semibold text-blue-800 mb-2">{name}</h3>
            <p className="text-gray-700 text-center mb-3">{description}</p>

            <p className="text-blue-700 font-semibold mb-3">Starting at {startingPrice} / seat</p>

            <ul className="text-gray-600 mb-6 list-disc list-inside space-y-1 text-sm">
              {features.map((feat, i) => (
                <li key={i}>{feat}</li>
              ))}
            </ul>

            <Link to={`/bookCabs?service=${id}`}>
              <button className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">
                Book Now
              </button>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
